import React from "react";
import Header from "./Header";
import Sample from "./Sample";

function Extra(){
    return(
        <>
        <Header></Header>
        <Sample></Sample>
        </>
    )
};

export default Extra